import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';


@Component({
    components: AllComponents(),
})
export default class OrderHistroyReceipt extends Mixins(CommonView) {

    public planOrderHistory: SBAPI.PlanOrderHistory = SBAPI.planOrderHistory();

    public planOrderGoodsList: SBAPI.PlanOrderGoods[] = []

    public error: string = "";

    public async created() {
        if (await this.isLoginRedirect(true)) return;

        let response = await SBAPI.PlanOrderHistoryController.getPlanOrderHistoryUsingGET(Number(this.$route.params.id)).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return
        };

        if (response.data.paymentStatus === 'BEFORE' || response.data.paymentStatus === 'CANCEL' || response.data.paymentStatus === 'ERROR') {//決済してない領収書は出さない
            this.$router.push("/mypage/orderHistroy");
        }
        this.planOrderHistory = response.data;
    }
}
